import { useQuery } from "react-query";
import axios from "infra/http";

function useSimpleList<T = { id: string; nome: string }>(url: string) {
  return useQuery(url, async () => {
    const { data } = await axios.get<T[]>(url);

    return data;
  });
}

export default useSimpleList;
